import React, { useState, useEffect } from 'react';
import HeaderWithIcon from '../../components/common/HeaderWithIcon';
import GameResultCard from './DrawResultCard';
import Calendar from '../../components/common/Calendar';
import { Button } from 'flowbite-react';

import { ChevronDown, ChevronUp } from 'lucide-react';

import { gamesApi } from '../../api/games';
import { useAuth } from '../../context/AuthContext';
import dayjs from 'dayjs';
import AddResultPopup from '../../components/Popup/AddResultPopup';

import Swal from 'sweetalert2';
import DrawResultCard from './DrawResultCard';

export default function DrawResult() {
  const [gameResults, setGameResults] = useState([]);
  const [gameSettings, setGameSettings] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedGame, setSelectedGame] = useState('');
  const [drawDate, setDrawDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [showAddPopup, setShowAddPopup] = useState(false);

  const fetchGameResults = async () => {
    const response = await gamesApi.fetchAllGameResults(drawDate, selectedGame);
    if (response.status === 200) {
      setGameResults(response.data);
    }
  };

  useEffect(() => {
    fetchGameResults();
  }, [drawDate, selectedGame]);

  const fetchGameSettings = async () => {
    const response = await gamesApi.getAllGames();
    if (response.status === 200) {
      setGameSettings(response.data);
    }
  };

  const fetchAllResults = async () => {
    try {
      await fetchGameResults();
      await fetchGameSettings();
    } catch (error) {
      Swal.fire({
        title: 'Error fetching results',
        text: error.message,
        icon: 'error',
      });
    }
  };

  useEffect(() => {
    fetchAllResults();
  }, [drawDate]);

  return (
    <>
      <div className='min-h-screen  relative overflow-hidden '>
        <HeaderWithIcon title='Draw Result' />

        <div className='px-5 pt-4'>
          <div className='flex gap-4 mb-1.5'>
            <div className=' flex-1'>
              <Calendar
                label='Draw Date'
                onDateChange={(date) =>
                  setDrawDate(dayjs(date).format('YYYY-MM-DD'))
                }
              />
            </div>

            <div className=' flex-1'>
              <label htmlFor='game' className='text-xs font-medium '>
                Select Game
              </label>
              <div className='relative w-full'>
                <button
                  id='dropdownButton'
                  className='w-full p-2.5 text-xs font-normal text-gray-700 bg-white border rounded-md shadow-sm flex justify-between items-center '
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span>
                    {gameSettings.find((game) => game.id === selectedGame)
                      ?.name || 'All'}
                  </span>
                  <span className='text-gray-500'>
                    {dropdownOpen ? (
                      <ChevronUp className='h-4 w-4' /> // ChevronUp icon for open state
                    ) : (
                      <ChevronDown className='h-4 w-4' /> // ChevronDown icon for closed state
                    )}
                  </span>
                </button>
                {dropdownOpen && (
                  <ul className='absolute left-0 z-10 w-full mt-1 bg-white border rounded-md shadow-md'>
                    <li
                      key='all'
                      onClick={() => {
                        setSelectedGame('');
                        setDropdownOpen(false);
                      }}
                      className={`p-2.5 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer border-b border-[#E1E7EF]`}
                    >
                      All
                    </li>
                    {gameSettings.map((game, index) => (
                      <li
                        key={game.id}
                        onClick={() => {
                          setSelectedGame(game.id);
                          setDropdownOpen(false);
                        }}
                        className={`p-2.5 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer ${
                          index !== 0 ? 'border-t border-[#E1E7EF]' : ''
                        }`}
                      >
                        {game.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>

          <div
            className='divide-y divide-gray-200  overflow-y-auto hide-scrollbar'
            style={{ height: 'calc(100vh - 150px)' }}
          >
            {gameResults.length > 0 ? (
              gameResults.map((result, index) => (
                <DrawResultCard
                  key={index}
                  {...result}
                  gameSettings={gameSettings}
                  refreshResults={fetchGameResults}
                />
              ))
            ) : (
              <div className='flex justify-center items-center h-full'>
                <p className='text-gray-500'>No results found</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
